import { OverflowMenu } from '@/exports/columnCommonComponents';
import { FileManagerInventoryFile } from '@/redux/slices/slice_types';
import FileMediaInfo from '../FileMediaInfo';
import FilePlay from '../FilePlay';
import FileDownload from '../FileDownload';
import { selectCanDownloadBucketInventory, selectCanViewMediaInfo } from '@/redux/selectors/authSelectors';
import { MEDIA_INFO_TYPES } from '@/constants/mediaConstants';
import styled from '@emotion/styled';
import { useAppSelector } from '@/redux/hooks';

// const VIDEO_FILETYPES = ['mov', 'mp4', 'mpg', 'avi'];

interface FileActionsProps {
  file: FileManagerInventoryFile;
  isMidAction?: boolean;
  handleDownload: (file: FileManagerInventoryFile) => void;
}

const FileActions = ({ file, isMidAction, handleDownload }: FileActionsProps) => {
  if (!file || file.ptype === 'FOLDER' || isMidAction) return null;
  const splitFilepath = file.key.split('.');
  const filetype = '.' + splitFilepath[splitFilepath.length - 1];

  const canDownload = useAppSelector(selectCanDownloadBucketInventory);
  // const canViewIQ = useAppSelector(selectCanViewIQ);
  const canViewMediaInfo = MEDIA_INFO_TYPES.includes(filetype) && useAppSelector(selectCanViewMediaInfo);
  // const canPlayVideo = VIDEO_FILETYPES.includes(filetype);
  const canPlayVideo = false;

  if (!canDownload && !canViewMediaInfo && !canPlayVideo) return null;

  return (
    <FileActionsWrapper hidden={!canDownload && !canViewMediaInfo && !canPlayVideo}>
      <OverflowMenu>
        {canPlayVideo && <FilePlay file={file} />}
        {canViewMediaInfo && <FileMediaInfo file={file} />}
        {canDownload && <FileDownload file={file} handleDownload={handleDownload} />}
      </OverflowMenu>
    </FileActionsWrapper>
  );
};

export default FileActions;

const FileActionsWrapper = styled.div<{ hidden: boolean }>`
  width: 20px;
  display: inline-flex;
  opacity: ${({ hidden }) => (hidden ? 0 : 1)};
  pointer-events: ${({ hidden }) => (hidden ? 'none' : 'auto')};
`;
